import cx from "classnames";
import Trophy from "@/components/svg/Trophy";
import { Hr_Runner, Maybe } from "@/graphql/gql/graphql";
import { getPickLabel } from "@/utils/horseRacing";
import { colorWhite } from "../../../styles/manualVars";
import ToolTip from "../toolTip/ToolTip";
import { pickStyles } from "./utils";
import styles from "./tableCells.module.scss";

interface HorseInfoProps {
  runner: Hr_Runner;
  saddleColor: string | undefined;
  numberColor: string | undefined;
  analysis?: string;
  pick?: {
    number: Maybe<number> | undefined;
    info: Maybe<string> | undefined;
  };
}

const HorseInfo = ({
  runner,
  pick,
  saddleColor,
  numberColor,
  analysis,
}: HorseInfoProps) => (
  <div
    className={cx(styles.horseInfoText, runner.scratched && styles.scratched)}
  >
    {pick?.number ? (
      <div className={cx(styles.topPicks, analysis && styles.toolTipContain)}>
        {analysis ? (
          <div className={styles.toolTip}>
            <ToolTip content={analysis} />
          </div>
        ) : (
          ""
        )}
        <div
          className={cx(
            styles.pickContainer,
            pickStyles(pick.number ?? undefined)
          )}
        >
          <Trophy />
          {getPickLabel(pick.number ?? undefined)}
        </div>
      </div>
    ) : (
      ""
    )}
    <div className={styles.horseNameContainer}>
      <div
        style={{
          backgroundColor: saddleColor,
          color: numberColor ?? colorWhite,
        }}
        className={styles.runnerIdBox}
      >
        {runner.runnerId}
      </div>
      <p className={styles.horseName}>{runner?.horseName}</p>
    </div>
    <div className={styles.desktopOnly}>
      {runner.jockey ? <p>{`Jockey: ${runner.jockey}`}</p> : ""}
      {runner.trainer ? <p>{`Trainer: ${runner.trainer}`}</p> : ""}
    </div>
    <div className={styles.mobileOnly}>
      {runner.jockey ? <p>{`J: ${runner.jockey}`}</p> : ""}
      {runner.trainer ? <p>{`T: ${runner.trainer}`}</p> : ""}
    </div>
  </div>
);

export default HorseInfo;
